import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import PublisherMarquee from './components/PublisherMarquee';
import WhyAkten from './components/WhyAkten';
import Principles from './components/Principles';
import Partners from './components/Partners';
import OurTeam from './components/OurTeam';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-stone-50">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <Services />
      <PublisherMarquee />
      <WhyAkten />
      <Principles />
      <Partners />
      <OurTeam />
      <FinalCTA />
      <Footer />
    </div>
  );
}
